import { Routes } from '@angular/router';
import { InitialDataResolver } from './app.resolver';
import { MainComponent } from './main/main.component';
import { AuthGuestGuard } from './shared/utils/auth-guest.guard';
import { AuthGuardNew } from './shared/utils/auth.guardnew';

export const routes: Routes = [


  { path: '', pathMatch: 'full', redirectTo: '' },
    {
    path: '',
    loadComponent: () => import('./main/main.component').then(m => m.MainComponent),
 
    resolve: {
      initialData: InitialDataResolver,
    },


    children: [
      { path: 'blog', loadChildren: () => import('./pages/blog/blog.route'), data: { breadcrumb: 'BLOG' , preload: false, } },
      { path: '', loadComponent: () => import('./home/home.component').then(m => m.HomeComponent) },
      { path: '', loadChildren: () => import('../app/pages/products/products.routes'), data: {preload: false, breadcrumb: 'All Products' } },
      { path: '', loadChildren: () => import('./pages/product/product.route'), data: { preload: false,breadcrumb: 'Product' } },
      { path: 'brochure', loadChildren: () => import('./pages/brochure/brochure.route'), data: { breadcrumb: 'Brochure', preload: false, } },

    ]

  },
   {
    path: 'products',
    loadComponent: () => import('../app/pages/products/products.component').then(m => m.ProductsComponent),

    children: [
      { path: 'products', loadChildren: () => import('../app/pages/products/products.routes'),  data: {preload: false} },

    ]
  },
  //  {
  //   path: '',
  //   loadComponent: () => import('./main/main.component').then(m => m.MainComponent),
  //   canActivate: [AuthGuardNew],
  //   resolve: {
  //     initialData: InitialDataResolver,
  //   },
  //   children: [
  //     { path: '', loadChildren: () => import('./pages/general/general.route'),  data: {preload: false} },


  //   ]
  // },
  {
    path: '',
    component: MainComponent,

    resolve: {
      initialData: InitialDataResolver,
    },


    children: [
      { path: '', loadChildren: () => import('./pages/general/general.route'), data: { preload: false } },

    ]

  },
  //  {
  //   path: '',
  //   loadComponent: () => import('../app/main/main.component').then(m => m.MainComponent),
  //   canActivate: [AuthGuestGuard],
  //   resolve: {
  //     initialData: InitialDataResolver,
  //   },
  //   children: [


  //   ]
  // }
  

];
